import { accessUploadTransactions } from '@/permissions/nil';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/upload-transactions',
		name: 'UploadTransactions',
		component: () => import('@/views/UploadTransactions.vue'),
		meta: {
			layout: 'LayoutAuthenticated',
			requiresAuth: true,
			title: 'pageUploadTransactions.metaTitle',
			permissionRule: accessUploadTransactions,
		},
	},
	{
		path: '/:username',
		name: 'AthletePublicProfile',
		component: () => import('@/views/AthletePublicProfile.vue'),
		props: true,
		meta: {
			layout: 'LayoutDefault',
			requiresAuth: false,
			title: 'pageAthletePublicProfile.metaTitle',
		},
	},
];

export default routes;
